<template>
    <div id="bimmake">
        <div class="title" v-if="type === 'BIMMAKE2520'">
          注册成功！恭喜您可试用软件14天，<br/>
            并获得软件<span style="color: #F67240;">全套学习视频！</span>
        </div>
        <div class="title" v-else-if="type === 'BIMMAKE3330'">恭喜您已注册成功获得14天免费使用权</div>
        <div class="title" v-else-if="type === 'BIMMAKE3331'">恭喜您已注册成功获得14天免费使用权</div>
        <div v-if="type === 'BIMMAKE2520'" class="button1" @click="skip">
            <img style="margin-right: 5px;height: 16px" src="@/assets/images/video.png"/>点此观看学习视频
        </div>
        <div class="sub-title-wrap" v-if="type === 'BIMMAKE2520'">
            <span class="sub-title-2520">扫码添加官方微信</span>
        </div>
        <div class="sub-title-wrap" v-else-if="type === 'BIMMAKE3330'">
            <span class="sub-title">获取“免费学习资料”</span>
            <!-- <span class="red-title">免费培训</span> -->
        </div>
        <div class="sub-title-wrap" v-else-if="type === 'BIMMAKE3331'">
            <span class="sub-title">广联达BIM施工深化软件BIMMAKE</span>
            <span class="red-title">免费培训</span>
        </div>
        <div class="bold-title" v-if="type === 'BIMMAKE2520'">
            <span class="normal">进群获取</span>
            <span class="high-light">答疑、免费培训</span>
            <span class="normal">等更多软件福利！</span>
            <!-- <span class="high-light">免费实操培训</span> -->
        </div>
        <div class="bold-title-3331" v-else-if="type === 'BIMMAKE3330'">请扫描下方二维码加QQ群</div>
        <div class="bold-title-3331" v-else-if="type === 'BIMMAKE3331'">案例实操，学钢筋算量，深化设计！</div>
        <div class="erweima">
            <img v-if="type === 'BIMMAKE2520'" :src="qrCode" alt="">
            <img v-else-if="type === 'BIMMAKE3330'" :src="BIMMAKE3330" alt="">
            <img v-else-if="type === 'BIMMAKE3331'" :src="BIMMAKE3331" alt="">
            <!-- <div v-if="type === 'BIMMAKE2520'" class="descript">添加官方微信</div> -->
            <div v-if="type === 'BIMMAKE3330'" class="descript">
                钢筋提量对量、翻样下料又准又快<br/>
                地上翻样下料 2000 ㎡/天，地下翻样下料 300 吨/天
            </div>
            <div v-else-if="type === 'BIMMAKE3331'" class="descript">扫码报名课程</div>
        </div>
    </div>
</template>

<script>
    import qrCode from '@/assets/images/qrcode5.png'
    import BIMMAKE3331 from '@/assets/images/bim3331.png'
    import BIMMAKE3330 from '@/assets/images/bim3330.png'
    // import maiFn from "@/utils/maidian";
    import UserEnterpriseApi from "@/api/userEnterpriseApi.js";
    export default {
        props: {
            type: String
        },
        data() {
            return {
                qrCode,
                BIMMAKE3331,
                BIMMAKE3330
            }
        },
        mounted() {
            const { sgyToken, globalId, version, source } = UserEnterpriseApi;
            // if (this.type === 'BIMMAKE2520') {
            //     maiFn(sgyToken, globalId, version, "show", this, "基础版页面显示", source);
            // } else if (this.type === 'BIMMAKE3330') {
            //     maiFn(sgyToken, globalId, version, "show", this, "翻样版页面显示", source);
            // } else if (this.type === 'BIMMAKE3331') {
            //     maiFn(sgyToken, globalId, version, "show", this, "旗舰版页面显示", source);
            // }
        },
        methods: {
            skip() {
                const { sgyToken, globalId, version, source } = UserEnterpriseApi;
                // maiFn(sgyToken, globalId, version, "click", this, "基础版点击链接", source);
                if (window.webObject && window.webObject.loadUrlInBrowser) {
                  window?.webObject?.loadUrlInBrowser('https://space.bilibili.com/473854985/channel/collectiondetail?sid=660986')
                } else {
                  window.open(
                    "https://space.bilibili.com/473854985/channel/collectiondetail?sid=660986",
                    "_blank"
                  );
                }
            }
        }
    }
</script>

<style scoped lang="scss">
#bimmake {
    .title {
        margin-top: 20px;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #3C5055;
        margin-top: 35px;
    }
    .button1 {
        margin: 20px auto;
        width: 197px;
        height: 45px;
        background: rgba(67, 138, 254);
        box-shadow: 0px 13px 18px rgba(20, 143, 233, 0.23);
        opacity: 1;
        border-radius: 50px;
        line-height: 45px;
        text-align: center;
        color: #FFFFFF;
        font-weight: bold;
        cursor: pointer;
        }
    .sub-title-wrap {
        margin-top: 40px;
        font-size: 22px;
        font-family: Source Han Sans CN;

        .sub-title-2520 {
            font-weight: bold;
        }
        .sub-title {
            font-weight: bold;
        }
        .red-title {
            font-weight: bold;
            color: #F67240;
        }
    }
    .bold-title {
        margin-top: 5px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        .normal {
            font-weight: 400;
        }
        .high-light {
            font-weight: bold;
            color: #F67240;
        }
    }
    .bold-title-3331 {
        margin-top: 5px;
        font-size: 20px;
        font-family: Source Han Sans CN;
    }
    .erweima {
        margin-top: 5px;
        &>img {
            height: 150px;
            width: 150px;
        }
    }
    .descript {
      margin-top: 10px;
      font-size: 14px;
      color: #838AA0;
    }
}
</style>
